import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SmsOptInModal from './SmsOptInModal'

const PUBLIC_URL = process.env.PUBLIC_URL || ''
const REDI_LOGO = `${PUBLIC_URL}/Redi-Platforms-Horz-transparentlogo.png`

function Header() {
  const year = new Date().getFullYear()
  const [isNavOpen, setIsNavOpen] = useState(false)
  const [smsModalOpen, setSmsModalOpen] = useState(false)

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen)
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container">
        <Link to="/" className="navbar-brand text-decoration-none">
          <img src={REDI_LOGO} alt="Redi Platforms" className="headerlogo" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          aria-expanded={isNavOpen}
          aria-controls="header-legal-nav"
          onClick={toggleNav}
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div
          id="header-legal-nav"
          className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`}
        >
          <div className="header-legal-nav ms-lg-auto">
            <span className="header-legal-item header-copyright d-none d-lg-inline">
              © {year} Redi Platforms, LLC
            </span>
            <span
              className="header-meta-sep d-none d-lg-inline"
              aria-hidden="true"
            >
              ·
            </span>
            <Link
              to="/privacy"
              className="header-legal-link"
              onClick={() => setIsNavOpen(false)}
            >
              Privacy Policy
            </Link>
            <span className="header-meta-sep" aria-hidden="true">
              ·
            </span>
            <Link
              to="/terms"
              className="header-legal-link"
              onClick={() => setIsNavOpen(false)}
            >
              Terms &amp; Conditions
            </Link>
            <span className="header-meta-sep" aria-hidden="true">
              ·
            </span>
            <button
              type="button"
              className="header-legal-link header-legal-button"
              onClick={() => {
                setSmsModalOpen(true)
                setIsNavOpen(false)
              }}
            >
              Receive SMS messages from us
            </button>
            <span className="header-legal-item header-copyright d-lg-none mt-2 w-100 text-lg-start">
              © {year} Redi Platforms, LLC
            </span>
          </div>
        </div>
      </div>

      <SmsOptInModal open={smsModalOpen} onClose={() => setSmsModalOpen(false)} />
    </nav>
  )
}

export default Header
